import "./confirm-issue-or-claim.scss";

document.addEventListener("DOMContentLoaded", () => {
  const $openers = document.querySelectorAll(".claim-or-issue-confirmation-button");

  const $modal = $("#claim-or-issue-confirmation-modal");
  // only either '.new_request_claim' or '.contactus-address-confirmation' form is present
  const $form = document.querySelector(".new_request_claim, .contactus-address-confirmation");

  $openers.forEach(opener => {
    opener.addEventListener("click", () => {
      if ($form.reportValidity()) {
        $modal.modal("show");
        $modal.find("button").first().trigger("focus");
      }
    });
  });

  const $submitBtn = $modal.find(".claim-or-issue-confirmation-modal__confirmation-submit-button");
  if ($submitBtn.length) {
    $submitBtn.on("click", e => {
      const btn = e.currentTarget;
      const originalValue = btn.value;
      setTimeout(() => {
        btn.disabled = true;
        btn.value = "Please wait...";
      }, 0);
      setTimeout(() => {
        if (document.contains(btn)) {
          btn.disabled = false;
          btn.value = originalValue;
        }
      }, 15000);
    });
  }
});
